module.exports = __webpack_public_path__ + "static/media/clean-design.0f928231.jpg";